module.exports = __webpack_public_path__ + "da08c5f92223d14b83b687bb66c3ba63.svg";